import React, { useState, useEffect } from "react";
import { useWaterCoolerContext } from "store/contexts/waterCoolerContext";
import Participant from "./Participant/Participant";
import WaterCoolerActionButtons from "./WaterCoolerActionButtons";
import { getAllMembers } from "services/TwilioService";

export default () => {
  const { room, channelInformation, notSupported, localVideo } =
    useWaterCoolerContext();
  const [participants, setParticipants] = useState([]);
  const [enableVideo, setEnableVideo] = useState(localVideo?.isTrackEnabled);
  const [members, setMembers] = useState(null);
  require('events').EventEmitter.defaultMaxListeners = 0;

  useEffect(() => {
    (async () => {
      try {
        var response = await getAllMembers(channelInformation);

        setMembers(response);
      } catch (e) {
        console.log(e);
      }
    })();
    //eslint-disable-next-line
  }, [participants]);

  useEffect(() => {
    if (room === null) {
      return;
    }

    (async () => {
      try {
        const participantConnected = (participant) => {
          setParticipants((prevParticipants) => [
            ...prevParticipants,
            participant,
          ]);
        };

        const participantDisconnected = (participant) => {
          setParticipants((prevParticipants) =>
            prevParticipants.filter((p) => p !== participant)
          );
        };

        const local = await room?.localParticipant;
        participantConnected(local);

        await room?.localParticipant.videoTracks.forEach(
          async (publication) => {
            await publication?.track.restart();
          }
        );

        await room?.participants.forEach(participantConnected);
        room.on("participantConnected", participantConnected);
        room.on("participantDisconnected", participantDisconnected);
      } catch (e) {
        console.log(e);
      }
    })();

    return () => {
      setEnableVideo(true);
    };

    //eslint-disable-next-line
  }, [room]);

  const remoteParticipants = participants.map((participant) => (
    <Participant
      notSupported={notSupported}
      key={participant.sid}
      members={members}
      enableVideo={enableVideo}
      participant={participant}
    />
  ));

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {remoteParticipants}
      </div>
      <WaterCoolerActionButtons
        notSupported={notSupported}
        room={room}
        changeVideo={() => setEnableVideo(!enableVideo)}
        enableVideo={enableVideo}
      />
    </div>
  );
};
